<div class="modal-buttons">
    
    <button 
        [disabled]="pageModal.isSaving" 
        class="button" 
        *ngIf="!pageModal.getCurrentModal().isProceedOnly"
        (click)="pageModal.closeModal()"
     data-ui-name="Page Modal close Modal" data-ui-component="modal-footer" data-testid="modal-footer-page-modal-close-modal"> <tra [slug]="pageModal.getCurrentModal().config.closeCaption ||closeMessage"></tra> </button>

    <button 
        *ngIf="confirmButton"
        [disabled]="isEditDisable || pageModal.isSaving" 
        class="button is-info" 
        (click)="confirmSubmission()"
     data-ui-name="Confirm Submission" data-ui-component="modal-footer" data-testid="modal-footer-confirm-submission">
        <tra [slug]="pageModal.getCurrentModal().confirmationCaption || pageModal.getCurrentModal().config.confirmationCaption || 'btn_ok'"></tra>
    </button>

</div>
